import { APP_USAGE_GUIDE_STEPS, appUsageGuideStepIndexForPath } from "@/shared/constants/appUsageGuide.const";
import { PortalUsageGuideModal } from "@/components/profile/PortalUsageGuideModal";

type AppUsageGuideBotProps = {
  opened: boolean;
  onClose: () => void;
  stepIndex: number;
  onStepChange: (index: number) => void;
};

export default function AppUsageGuideBot({ opened, onClose, stepIndex, onStepChange }: AppUsageGuideBotProps) {
  return (
    <PortalUsageGuideModal
      opened={opened}
      onClose={onClose}
      stepIndex={stepIndex}
      onStepChange={onStepChange}
      steps={APP_USAGE_GUIDE_STEPS}
      stepIndexForPath={appUsageGuideStepIndexForPath}
    />
  );
}
